import { render, staticRenderFns } from "./CartPayMethodSelector.vue?vue&type=template&id=537fa264&scoped=true"
import script from "./CartPayMethodSelector.vue?vue&type=script&lang=js"
export * from "./CartPayMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./CartPayMethodSelector.vue?vue&type=style&index=0&id=537fa264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fa264",
  null
  
)

export default component.exports